import React, {Component} from 'react';
import {translate} from 'react-i18next';
import PageHeader from "../elements/PageHeader";
import ProfileUserBlockContainer from '../../containers/blocks/profile/ProfileUserBlockContainer';

class ProfileScreen extends Component {
    render() {
        const {t} = this.props;
        return (
            <div className="ProfileScreen">
                <PageHeader title={t('profileScreen.title')}/>
                <div className="row m-t">
                    <div className="col-lg-6">
                        <ProfileUserBlockContainer/>
                    </div>
                    <div className="col-lg-6">
                    </div>
                </div>
            </div>
        )
    }
}

export default translate()(ProfileScreen);